import { getChain, type ChainTag } from "@umi/shared/chains";
import { nativeToUsd } from "@umi/shared/priceFeed";
import { acceptHMRUpdate, defineStore } from "pinia";


interface State {
  usdPrices: Record<string, bigint>,
  fiatMode: boolean,
}

export const useChainStore = defineStore("chain", {

  state: (): State => ({
    usdPrices: {},
    fiatMode: false,
  }),

  getters: {

    usdPrice: (state) => (chainTag: ChainTag, value?: bigint) => {
      const chain = getChain(chainTag);
      const symbol = chain.currency.symbol;
      const price = state.usdPrices[symbol] ?? 0n;
      const usd = nativeToUsd(value ?? 1n, chainTag, price);
      return { usd, sub1Cent: usd < 0.01 };
    },

  }

});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useChainStore, import.meta.hot));
}
